import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  ImageField,
  NumberInput,
  NumberField,
  SelectInput,
  UrlField,
} from "react-admin";
import { CustomDeleteButton } from './CustomDeleteButtons';

const ProductFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="name" alwaysOn />
    <SelectInput source="category" label="Category" choices={[
      { id: 'balls', name: 'Balls' },
      { id: 'clubs', name: 'Clubs' },
      { id: 'apparel', name: 'Apparel' },
      { id: 'accessories', name: 'Accessories' },
    ]} />
  </Filter>
);

export const ProductList = (props) => (
  <List {...props} filters={<ProductFilter />}>
    <Datagrid>
      <TextField source="name" label="Product Name" />
      <TextField source="brand" label="Brand Name" />
      <NumberField source="price" label="Price" options={{ style: 'currency', currency: 'USD' }} />
      <TextField source="category" label="Category" />
      <ImageField source="image_url" label="Image" />
      <UrlField source="shop_url" label="Shop Link" />
      <ShowButton label="" />
      <EditButton label="" />
      <CustomDeleteButton label="" redirect={false}/>
    </Datagrid>
  </List>
);

export const ProductShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Product Name" />
      <TextField source="brand" label="Brand Name" />
      <NumberField source="price" label="Price" options={{ style: 'currency', currency: 'USD' }} />
      <TextField source="category" label="Category" />
      <ImageField source="image_url" label="Image" />
      <UrlField source="shop_url" label="Shop Link" />
      <TextField source="description" label="Description" />
    </SimpleShowLayout>
  </Show>
);

export const ProductCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Product Name" />
      <TextInput source="brand" label="Brand Name" />
      <NumberInput source="price" label="Price" />
      <SelectInput source="category" label="Category" choices={[
        { id: 'balls', name: 'Balls' },
        { id: 'clubs', name: 'Clubs' },
        { id: 'apparel', name: 'Apparel' },
        { id: 'accessories', name: 'Accessories' },
      ]} />
      <TextInput source="image_url" label="Image URL" />
      <TextInput source="shop_url" label="Shop Link" />
      <TextInput source="description" label="Description" multiline />
    </SimpleForm>
  </Create>
);

export const ProductEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" label="Product Name" />
      <TextInput source="brand" label="Brand Name" />
      <NumberInput source="price" label="Price" />
      <SelectInput source="category" label="Category" choices={[
        { id: 'balls', name: 'Balls' },
        { id: 'clubs', name: 'Clubs' },
        { id: 'apparel', name: 'Apparel' },
        { id: 'accessories', name: 'Accessories' },
      ]} />
      <TextInput source="image_url" label="Image URL" />
      <TextInput source="shop_url" label="Shop Link" />
      <TextInput source="description" label="Description" multiline />
    </SimpleForm>
  </Edit>
); 